import { ContributorGroupsGridView } from '~/components/contributors/groups';
import { PageContainer } from '~/components/page-container';

export function ContributorGroups() {
	return (
		<PageContainer>
			<ContributorGroupsGridView />
		</PageContainer>
	);
}
